import { IContractRates } from '../model/HiringContract/IContractRates';
import { IPaginationResult } from '../model/search/IPaginationResult';
import ContractType from '../model/enum/ContractType';

//Contract Rates,
export const getContractRates = (contractRatesPaginationResult: IPaginationResult<IContractRates>, rateTypeId: number) => {
  if (contractRatesPaginationResult.data && contractRatesPaginationResult.status) {
    const result = contractRatesPaginationResult.data.find((value) => value.crtyId === rateTypeId);
    return result;
  } else {
    return undefined;
  }
};

export const FindDefaultRate = (contractRates: IContractRates[], contractType: string) => {
  if (!contractRates || contractRates.length === 0) {
    return 0;
  }
  let rateTypeId = 0;
  if (contractType === ContractType.long) {
    const priorityOrder = [279, 280, 105, 255, 1]; // Primary, Secondary, Mars, Dry, Wet
    rateTypeId = priorityOrder.find((id) => contractRates.some((v) => v.crtyId === id)) ?? 0;
  } else {
    const priorityOrder = [255, 1, 105]; // Dry, Wet, Mars, Primary, Secondary
    rateTypeId = priorityOrder.find((id) => contractRates.some((v) => v.crtyId === id)) ?? 0;
  }
  return rateTypeId;
};
